import React from "react";
import './Footer.css';
import logo from "../../Images/Logo Bez Tekstu.svg";

export default function Footer(){
	return(
		<div className='footer'>
			<div className='oneOfThree'>
				<p className='text'>Ignacy Mermer</p>
				<p className='text'>Jan Burdzicki</p>
			</div>
			<div className='oneOfThree'>
				<img
					src={logo}
					className='logoFooter'
				/>
			</div>
			<div className='oneOfThree'>
				<p className='text'>IX Liceum im. C. K. Norwida w Częstochowie</p>
				<p className='text'>Konkurs "Młody Einstein"</p>
			</div>
		</div>
	);
}